import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../shared/AppSettings";
import { invoiceData } from "../model/invoiceData.model";
import { Observable } from "rxjs";

@Injectable()
export class InvoiceService {
  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) {}

  // Customer ----------------------------------------------------------

  public GetCustomerInvoiceStatuses() {
    return this.httpClient.get(
      `${this.rootUrl}/api/CustomerInvoice/GetCustomerInvoiceStatuses`
    );
  }

  public getCustomerInvoices(invoiceFilter) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/GetCustomerInvoices`,
      invoiceFilter,
      { headers }
    );
  }

  public getCustomerInvoiceDetails(invoiceFilterByInvoiceIdEncoded) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/GetCustomerInvoiceDetails`,
      invoiceFilterByInvoiceIdEncoded,
      { headers }
    );
  }

  public getInvoiceFileStream(invoiceFilterByInvoiceIdEncoded) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/getInvoiceFileStream`,
      invoiceFilterByInvoiceIdEncoded,
      { headers }
    );
  }

  public getInvoiceFile(invoiceFilterByInvoiceIdEncoded) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/getInvoiceFile`,
      invoiceFilterByInvoiceIdEncoded,
      { headers, responseType: "blob" }
    );
  }

  public confirm1(confirmData) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/Confirm1`,
      confirmData,
      { headers }
    );
  }

  public confirm2(confirmData) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/Confirm2`,
      confirmData,
      { headers }
    );
  }

  public confirm21(confirmData) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/Confirm21`,
      confirmData,
      { headers }
    );
  }

  public confirm3(confirmData) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/Confirm3`,
      confirmData,
      { headers }
    );
  }

  public reject1(confirmData) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/Reject1`,
      confirmData,
      { headers }
    );
  }

  public reject2(confirmData) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/Reject2`,
      confirmData,
      { headers }
    );
  }

  public reject3(confirmData) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/Reject3`,
      confirmData,
      { headers }
    );
  }

  public RejectReturnToSupplier(confirmData) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/RejectReturnToSupplier`,
      confirmData,
      { headers }
    );
  }

  public redirect(confirmData) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/Redirect`,
      confirmData,
      { headers }
    );
  }

  // Supplier ----------------------------------------------------------

  public GetSupplierInvoiceStatuses() {
    return this.httpClient.get(
      `${this.rootUrl}/api/SupplierInvoice/GetSupplierInvoiceStatuses`
    );
  }

  public getSupplierInvoices(invoiceFilter) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/SupplierInvoice/GetSupplierInvoices`,
      invoiceFilter,
      { headers }
    );
  }

  public getSupplierInvoiceDetails(invoiceFilterByInvoiceIdEncoded) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/SupplierInvoice/GetSupplierInvoiceDetails`,
      invoiceFilterByInvoiceIdEncoded,
      { headers }
    );
  }

  // LP ------------------------------------------------------------------

  public validateInvoiceLP(invoiceFilterByInvoiceIdEncoded) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/LPInvoice/ValidateInvoiceLP`,
      invoiceFilterByInvoiceIdEncoded,
      { headers }
    );
  }

  // public confirm2(confirmData) {
  //   const headers = new HttpHeaders().set('content-type', 'application/json');
  //   return this.httpClient.post(`${this.rootUrl}/api/CustomerInvoice/Confirm2`, confirmData, { headers });
  // }

  // public confirm21(confirmData) {
  //   const headers = new HttpHeaders().set("content-type", "application/json");
  //   return this.httpClient.post(
  //     `${this.rootUrl}/api/CustomerInvoice/Confirm21`,
  //     confirmData,
  //     { headers }
  //   );
  // }

  public confirmDataList(invoiceData : invoiceData[], statusChange) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/CustomerInvoice/ConfirmDataList?StatusChange=${statusChange}`,
      invoiceData,
      { headers }
    );
  }

public downloadInvoiceFile(invoiceId: number): Observable<Blob> {
  return this.httpClient.get(
    `${this.rootUrl}/api/CustomerInvoice/File/${invoiceId}`,
    { responseType: 'blob' }
  );
}


}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/service/invoice.service.ts